// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1lu0B","content":"styles_content__2brhM","checkbox":"styles_checkbox__F1eMQ","checkboxLabel":"styles_checkboxLabel__3-PRJ"};